import { defineMessages } from 'react-intl-next';

export default defineMessages({
	hideItem: {
		id: 'navigation.global-side-navigation.nav-item.actions.hide-item',
		defaultMessage: 'Hide from sidebar',
		description: 'Label for the actions menu item to hide the item from the menu',
	},
	showItem: {
		id: 'navigation.global-side-navigation.nav-item.actions.show-item',
		defaultMessage: 'Show in sidebar',
		description: 'Label for the actions menu item to show the item in the menu',
	},
});
